import { Cart, UpdateCartDto } from '../interfaces/cart.interface';
import api from './';

export const { useGetCartQuery, useUpdateCartMutation } = api.injectEndpoints({
  endpoints: (build) => ({
    getCart: build.query<Cart, void>({
      query: () => ({
        url: 'cart',
      }),
      providesTags: ['cart'],
    }),
    updateCart: build.mutation<Cart, UpdateCartDto>({
      query: (body) => ({
        url: 'cart',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['cart'],
    }),
  }),
});
